module.exports = __webpack_public_path__ + "static/media/11.7dbf5fb3.png";